import { useEffect, useState } from "react";
import { makeStyles } from "tss-react/mui";
import { VerticalColorPalette } from "components";
import { icons } from "constants/viewer";
import { RasterIcon } from "assets/images";
import ViewerEvents from "events/ViewerEvents";
import { getFileIcon, getFileType } from "actions/GlobalActions";
import GradientActions from "actions/GradientActions";
import { Widgets, LocalShipping } from "@mui/icons-material";
import { ReactComponent as Excavator } from "assets/branding/Excavator.svg";
import { ReactComponent as File } from "assets/images/file.svg";
import { defaultBorder, panelBackgroundColor, iconColor } from "styles/common";

const iconLibrary: any = {};
const dimension = 36;
const _margin = 6;
const useStyles = makeStyles<{ margin: any }>() ((theme, { margin }) => ({
    root: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: dimension + _margin * 2,
        height: "100%",
        borderRight: margin ? `1px solid ${theme.palette.divider}` : "",
    },
    content: {
        width: dimension,
        height: dimension,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "50%",
        overflow: "hidden",
    },
    layerIcon: {
        width: 30,
        height: 30,
        backgroundColor: theme.palette.text.secondary,//panelBackgroundColor,
        borderRadius: "50%",
        position: "absolute",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
    },
    icon: {
        width: 24,
        height: 24,
        color: iconColor,
    },
}));

export var getIcon = (layer: any, inputs: any, classes: any) => {
    const layerId = layer.ID;
    const currentProject = ViewerEvents.currentProject;
    if (layer.not_selectable) {
        const Icon = icons["VOXMESH"];
        return (
            <div className={classes.layerIcon}>
                <Icon className={classes.icon} />
            </div>
        );
    }
    if (inputs) {
        let meta = inputs[layer.view_type];
        if (meta) {
            const input: any = Object.values(meta).find((input: any) => input.type === "3");
            //console.log("input:", input);
            if (input) {
                const input_id = input.id;
                const input_value = layer["input_value_" + input_id];
                //console.log("id:", input_id, "|value:", input_value);
                if (input_value) {
                    const file = currentProject[input_value];
                    //console.log("****LayerIcon:", "|" , file);
                    var fileName = "";
                    if (file) {
                        fileName = getFileIcon(file);
                    } else {
                        fileName = getFileType(layer);
                    }
                    if (fileName) {
                        //console.log("fileName:", fileName);
                        const Icon = icons[fileName];
                        if (Icon) {
                            iconLibrary[layer.ID] = <Icon className={classes.icon} />;
                            return (
                                <div className={classes.layerIcon}>
                                    <Icon className={classes.icon} />
                                </div>
                            );
                        }
                    }
                }
            }
        }
    }
    if (layer["view_type"] === "com.voxelfarm.program.view.truck") {
        return (
            <div className={classes.layerIcon}>
                <LocalShipping className={classes.icon} />
            </div>
        );
    }

    if (layer["view_type"] === "com.voxelfarm.program.view.excavator") {
        return (
            <div className={classes.layerIcon}>
                <Excavator className={classes.icon} />
            </div>
        );
    }

    if (layer["view_type"] === "com.voxelfarm.program.view.planegenerator" || layer["view_type"] === "raster") {
        return (
            <div className={classes.layerIcon}>
                <RasterIcon className={classes.icon} />
            </div>
        );
    }
    switch (layerId) {
        case "277F786F04E545B9A5CE1AA1954B3857":
            return (
                <div className={classes.layerIcon}>
                    <Widgets className={classes.icon} />
                </div>
            );
        default:
            return (
                <div className={classes.layerIcon}>
                    <File className={classes.icon} />
                </div>
            );
    }
};

type LayerIconProps = {
    layer: any;
    inputs?: any;
    style?: any;
    className?: any;
    margin?: boolean;
    onInputsCallback?: (inputs: any) => void;
};

export default function LayerIcon(props: LayerIconProps) {
    var { layer, inputs } = props;

    var { classes } = useStyles({ margin: props.margin });
    if (!inputs) {
        inputs = ViewerEvents.inputs;
    }
    useEffect(() => {
        const onUpdate = (updatedLayer: any) => {
            //console.log('updateColorLegend', updatedLayer);
            setUpdate((prevUpate: boolean) => !prevUpate);
        };
        ViewerEvents.on("updateColorLegend", onUpdate);
        return () => {
            ViewerEvents.removeEventListener("updateColorLegend", onUpdate);
        };
    }, []);
    const [update, setUpdate] = useState(false);
    const colors = GradientActions.getLayerColors(layer);
    //console.log("colors:", colors);
    return (
        <div className={classes.root} style={{ userSelect: update ? "none" : "none" }}>
            <div className={classes.content}>
                <VerticalColorPalette colors={colors} width={dimension} />
                {getIcon(layer, inputs, classes)}
            </div>
        </div>
    );
}
